import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Form } from 'semantic-ui-react';
import { reduxForm, Field } from 'redux-form';
import { getValidations } from '../helpers/validationByFieldType';
import Picture from './Picture';

// components

class PictureForm extends PureComponent {
  static propTypes = {
    season: PropTypes.object.isRequired,
  };
  render() {
    const { season } = this.props;
    return (
      <Form>
        <Field
          name="photoUrl"
          season={season}
          component={Picture}
          validate={getValidations(true)}
        />
      </Form>
    );
  }
}

export default reduxForm({ destroyOnUnmount: false })(PictureForm);



// WEBPACK FOOTER //
// ./src/components/PictureForm.js